import { EmailDisplay } from '../utils/emailObfuscator';
import { Mail, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
export const FooterHTAG = ({ whiteBg }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const footerClass = whiteBg
    ? 'bg-white text-slate-700 py-20 px-4 lg:px-8 border-t border-slate-200'
    : 'bg-gradient-to-t from-[#0f1219] via-[#181C25] to-[#212635] text-gray-300 py-20 px-4 lg:px-8';
  const titleClass = whiteBg
    ? 'font-montserrat font-bold text-slate-900 mb-4'
    : 'font-montserrat font-bold text-white mb-4';
  const aboutTextClass = whiteBg
    ? 'text-sm text-slate-500 leading-relaxed'
    : 'text-sm text-gray-400 leading-relaxed';
  const linkClass = whiteBg
    ? 'hover:text-blue-600 transition-colors'
    : 'hover:text-blue-500 transition-colors';
  const dividerClass = whiteBg
    ? 'border-t border-slate-200 my-8'
    : 'border-t border-gray-800 my-8';
  const bottomTextClass = whiteBg
    ? 'text-sm text-slate-500 font-acumin'
    : 'text-sm text-gray-500 font-acumin';
  const socialBgClass = whiteBg
    ? 'w-8 h-8 rounded-full bg-slate-100 hover:bg-blue-600 flex items-center justify-center text-blue-600 hover:text-white transition-all border border-slate-200'
    : 'w-8 h-8 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center text-gray-400 hover:text-white transition-all';
  const legalLinkClass = whiteBg
    ? 'text-slate-500 hover:text-blue-600 transition-colors'
    : 'text-gray-500 hover:text-blue-500 transition-colors';
  const separatorClass = whiteBg ? 'text-slate-300' : 'text-gray-700';

  return (
    <footer className={footerClass + ' w-full'}>
      <div className="container mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12"
        >
          {/* About */}
          <div>
            <div className="flex items-center space-x-3 mb-6 font-acumin">
              <img
                src="/logo.png"
                alt="HTAG Facility Logo"
                className="h-24 w-auto"
              />
            </div>
            <p className={aboutTextClass}>
              Expert en transformation digitale, développement web et conseil pour TPE/PME.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className={titleClass}>Navigation</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: 'Accueil', href: '#accueil' },
                { label: 'Services', href: '#services' },
                { label: 'À propos', href: '#apropos' },
                { label: 'FAQ', href: '#faq' },
              ].map((item, idx) => (
                <li key={idx}>
                  <a
                    href={item.href}
                    className={linkClass}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className={titleClass}>Services</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: 'Accompagnement 360°', path: '/services/accompagnement' },
                { label: 'Design & Web', path: '/services/design-web' },
                { label: 'Dépannage & Fibre', path: '/services/depannage' },
                { label: 'Coaching Équipe', path: '/services/coaching' },
              ].map((service, idx) => (
                <li key={idx}>
                  <button
                    onClick={() => navigate(service.path)}
                    className={linkClass + ' cursor-pointer text-left'}
                  >
                    {service.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className={titleClass}>Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center space-x-3">
                <Mail className={whiteBg ? 'w-4 h-4 text-blue-600' : 'w-4 h-4 text-blue-500'} />
                <EmailDisplay className={linkClass} />
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className={whiteBg ? 'w-4 h-4 text-blue-600' : 'w-4 h-4 text-blue-500'} />
                <span>Château-Porcien, France</span>
              </li>
            </ul>
          </div>
        </motion.div>

        {/* Divider */}
        <div className={dividerClass}></div>

        {/* Bottom */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
        >
          <p className={bottomTextClass}>
            &copy; {currentYear} HTAG Facility. Tous droits réservés.
          </p>

          {/* Social Links */}
          <div className="flex space-x-6">
            {[
              { icon: Linkedin, href: '#' },
              { icon: Twitter, href: '#' },
              { icon: Facebook, href: '#' },
            ].map((social, idx) => {
              const Icon = social.icon;
              return (
                <a
                  key={idx}
                  href={social.href}
                  className={socialBgClass}
                >
                  <Icon size={16} />
                </a>
              );
            })}
          </div>

          {/* Legal Links */}
          <div className="flex space-x-4 text-sm">
            <a href="/legal-notice" className={legalLinkClass}>
              Mentions légales
            </a>
            <span className={separatorClass}>|</span>
            <a href="/privacy-policy" className={legalLinkClass}>
              Politique de confidentialité
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default FooterHTAG;
